export default () => ({
  alls: [],
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/forall/resources/data.js